import {Component, OnInit} from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {AboutService, VersionInfo} from '../../services/about/about.service';
import {APP_NAME, COPYRIGHT} from '@twpub/core/constants';
import {NGXLogger} from 'ngx-logger';
import {CdkScrollable} from '@angular/cdk/scrolling';

import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {LicenseDisplayComponent} from './license-display/license-display.component';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'pub-about-dialog',
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatProgressSpinner, LicenseDisplayComponent, MatDialogActions, MatButton]
})
export class AboutDialogComponent implements OnInit {
  versionInfo: VersionInfo | null = null;
  loading = true;
  error = false;
  protected readonly APP_NAME = APP_NAME;
  protected readonly COPYRIGHT = COPYRIGHT;

  aboutTitle = $localize`:@@about.title:About`;
  loadingLabel = $localize`:@@about.loading:Loading...`;
  errorMessage = $localize`:@@about.error:Error loading version information. Please try again later.`;
  versionLabel = $localize`:@@about.version:version`;
  unknownVersion = $localize`:@@about.unknownVersion:Unknown`;
  privacyPolicyPrefix = $localize`:@@about.privacyPolicyPrefix:By using ${APP_NAME} you accept the terms provided in our`;
  privacyPolicyLink = $localize`:@@about.privacyPolicyLink:Data Privacy Policy`;
  frontendLibrariesLabel = $localize`:@@about.frontendLibraries:Frontend Libraries`;
  backendLibrariesLabel = $localize`:@@about.backendLibraries:Backend Libraries`;
  closeLabel = $localize`:@@about.close:Close`;

  constructor(private logger: NGXLogger, private aboutService: AboutService, private dialogRef: MatDialogRef<AboutDialogComponent>) {
  }

  ngOnInit(): void {
    this.aboutService.getVersionInfo().subscribe({
      next: (info) => {
        this.versionInfo = info;
        this.loading = false;
      },
      error: (err) => {
        this.logger.error('Error loading version info:', err);
        this.error = true;
        this.loading = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
